import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-close-danger-svg-icon',
  imports: [NgClass],
  templateUrl: './close-danger-svg-icon.component.html',
  styleUrl: './close-danger-svg-icon.component.css',
})
export class CloseDangerSvgIconComponent {
  @Input({ required: true }) class!: string;
}
